import { LvfAppModule } from '../../enum/application/lvf-app-module';
import { Guid } from '../../types/guid.type';
import { IUnitInfo, Unit } from '../core/unit';
import { EntityDocumentStatusBase, IEntityDocumentStatusBaseInfo } from '../entity/document/entity-document-status.base';

import { IProductInfo, Product } from '../sales/product';
import { IEquipmentVehicleInfo, EquipmentVehicle } from '../supply-chain/vehicle/equipment-vehicle';
import { IEquipmentTypeInfo, EquipmentType } from '../supply-chain/vehicle/equipment-type';
import { IPersonInfo, PersonInfo } from '../core/person-info';

export interface ITicketDeliveryProductInfo extends IEntityDocumentStatusBaseInfo {
  TicketDeliveryUid?: Guid;
  ProductUid?: Guid;
  Product?: IProductInfo;
  VehicleUid?: Guid;
  EquipmentVehicle?: IEquipmentVehicleInfo;
  VehicleTypeUid?: Guid;
  EquipmentTypeUid?: Guid;
  VehicleType?: IEquipmentTypeInfo;
  EquipmentType?: IEquipmentTypeInfo;
  Quantity?: number;
  UnitUid?: Guid;
  Unit?: IUnitInfo;
  Comment?: string;
  ProductLabel?: string;
  AuthorUid?: Guid;
  Author?: IPersonInfo;
}

export class TicketDeliveryProduct extends EntityDocumentStatusBase {
  TicketDeliveryUid?: Guid;
  ProductUid?: Guid;
  Product?: Product;
  VehicleUid?: Guid;
  EquipmentVehicle?: EquipmentVehicle;
  VehicleTypeUid?: Guid;
  EquipmentTypeUid?: Guid;
  VehicleType?: EquipmentType;
  EquipmentType?: EquipmentType;
  Quantity?: number;
  Comment?: string;
  ProductLabel?: string;
  UnitUid?: Guid;
  Unit?: Unit;
  AuthorUid?: Guid;
  Author?: PersonInfo;

  // Client side properties
  ShowError?: boolean;

  constructor(info: ITicketDeliveryProductInfo) {
    super(info);
    this.LvfAppModule = LvfAppModule.TICKET;

    this.TicketDeliveryUid = info.TicketDeliveryUid;
    this.ProductUid = info.ProductUid;
    this.Product = Product.createInstance(Product, info.Product);
    this.VehicleUid = info.VehicleUid;
    this.EquipmentVehicle = info.EquipmentVehicle ? new EquipmentVehicle(info.EquipmentVehicle) : undefined;
    this.EquipmentTypeUid = info.EquipmentTypeUid ?? info.VehicleTypeUid;
    this.VehicleTypeUid = this.EquipmentTypeUid;
    this.EquipmentType = EquipmentType.createInstance(EquipmentType, info.EquipmentType ?? info.VehicleType);
    this.VehicleType = this.EquipmentType;
    this.Quantity = info.Quantity;
    this.Comment = info.Comment;
    this.ProductLabel = info.ProductLabel;
    this.UnitUid = info.UnitUid;
    this.Unit = Unit.createInstance(Unit, info.Unit);
    this.AuthorUid = info.AuthorUid;
    this.Author = PersonInfo.createInstance(PersonInfo, info.Author);
  }
}
